import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["allowClearSearch", "allowEnterSearch", "className", "prefix", "enterButton", "onPressEnter", "onSearch"];
import * as React from 'react';
import omit from 'lodash/omit';
import SearchIcon from '@bedrock/icons-react/Search';
import InputBase, { INPUT_PREFIX_CLS } from './InputBase';
import { ConfigContext, SizeContext, LocaleContext } from '../ConfigProvider';
import Button from '../Button';
var useCallback = React.useCallback,
    useContext = React.useContext,
    useMemo = React.useMemo,
    useRef = React.useRef;
export function clearTargetValue(e) {
  var event = Object.create(e);
  return event;
}
var Search = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _useContext = useContext(ConfigContext),
      getPrettyCls = _useContext.getPrettyCls,
      getLocale = _useContext.getLocale;

  var contextSize = useContext(SizeContext);
  var contextLocale = useContext(LocaleContext);
  var localeMessages = getLocale(contextLocale, 'Input');

  var allowClearSearch = props.allowClearSearch,
      allowEnterSearch = props.allowEnterSearch,
      className = props.className,
      prefix = props.prefix,
      enterButton = props.enterButton,
      onPressEnter = props.onPressEnter,
      onSearch = props.onSearch,
      rest = _objectWithoutProperties(props, _excluded);

  var _rest$allowClear = rest.allowClear,
      allowClear = _rest$allowClear === void 0 ? true : _rest$allowClear,
      autoFocus = rest.autoFocus,
      prefixCls = rest.prefixCls,
      onChange = rest.onChange,
      onClear = rest.onClear;
  var disabled = rest.disabled;
  var inputRef = ref || useRef(null); // history reason
  // omit the "allowClear", because Search custom

  var omitProps = omit(rest, ['onClear']);
  var handleClear = useCallback(function (e) {
    var event = clearTargetValue(e);

    if (onChange) {
      onChange(event);
    }

    if (onClear) {
      onClear(e);
    }

    if (allowClearSearch && onSearch) {
      onSearch('', e);
    }

    if (autoFocus) {
      var _inputRef$current;

      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.focus();
    }
  }, [allowClearSearch, autoFocus, inputRef, onChange, onClear, onSearch]);
  var handleEnter = useCallback(function (e) {
    var _inputRef$current2;

    if (onPressEnter) {
      onPressEnter(e);
    }

    if (allowEnterSearch && onSearch && ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.input)) {
      onSearch(inputRef.current.input.value, e);
    }
  }, [allowEnterSearch, inputRef, onPressEnter, onSearch]);
  var handleSearch = useCallback(function (e) {
    var _inputRef$current3;

    if (disabled) {
      return;
    }

    if (onSearch && ((_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.input)) {
      onSearch(inputRef.current.input.value, e);
    }
  }, [disabled, inputRef, onSearch]);
  var prefixNode = useMemo(function () {
    var prefixIcon = prefix || /*#__PURE__*/React.createElement(SearchIcon, {
      className: getPrettyCls("".concat(INPUT_PREFIX_CLS, "-prefix-search-icon"), prefixCls)()
    });

    if (enterButton && !prefix) {
      return null;
    }

    return /*#__PURE__*/React.cloneElement(prefixIcon, {
      onClick: handleSearch
    });
  }, [enterButton, getPrettyCls, handleSearch, prefix, prefixCls]);
  /* eslint-disable-next-line */
  // const suffixNode = useMemo(() => {
  //   const suffixIcon = suffix || <CloseCircleFilled />;
  //   if (!value || !allowClear) {
  //     return null;
  //   }
  //   return React.cloneElement(suffixIcon as React.ReactElement, { onClick: handleClear });
  // }, [allowClear, handleClear, suffix, value]);

  var addonAfterNode = useMemo(function () {
    return enterButton ? /*#__PURE__*/React.createElement(Button, {
      onClick: handleSearch
    }, typeof enterButton !== 'boolean' ? enterButton : /*#__PURE__*/React.createElement(SearchIcon, null)) : null;
  }, [enterButton, handleSearch]);
  return /*#__PURE__*/React.createElement(InputBase, _objectSpread({
    className: getPrettyCls("".concat(INPUT_PREFIX_CLS, "-search-wrapper"), prefixCls, className)({
      'with-button': !!enterButton
    }),
    isBorderRound: true,
    prefix: prefixNode,
    ref: inputRef,
    getPrettyCls: getPrettyCls,
    onPressEnter: handleEnter,
    onClear: handleClear,
    allowClear: allowClear,
    addonAfter: addonAfterNode,
    size: contextSize,
    placeholder: localeMessages.placeholder
  }, omitProps));
});
Search.defaultProps = {
  allowClearSearch: true,
  allowEnterSearch: true
};
Search.displayName = 'Search';
export default Search;